export default __webpack_public_path__ + "static/media/may-2018.518aa7f2.csv";